import { useNode } from "@craftjs/core";
import React, { useContext, useLayoutEffect } from "react";
import { APIProviderContext } from "../../api";
import { UnitInput, Spacer, Tabs, AlignInput, TextInput } from "../../input";
import { supportLibrary } from "../../block-supports";
import { isUpdatedFromDefault } from "../../utils";
import { INPUT_LIMITS } from "../../input-limits";

export const TwitterSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));
  const { getTweet } = useContext(APIProviderContext);

  const {
    url,
    tweet,
    width,
    widthMobile,
    widthTablet,
    height,
    heightTablet,
    heightMobile,
    align,
    alignTablet,
    alignMobile,
  } = props;

  function GeneralSettings() {
    return (
      <div className="g-settings__wrapper">
        <Spacer spacing={"1rem"}>
          <TextInput
            minLength={INPUT_LIMITS["outbound-link"].minlength}
            maxLength={INPUT_LIMITS["outbound-link"].maxlength}
            isResponsive={true}
            resetValue={undefined}
            value={url}
            onChange={(val) => {
              setProp((props) => {
                props.url = val;
              });
            }}
            label={"Tweet URL"}
          />
          <button
            onClick={(e) => {
              if (!url) return;
              getTweet(url)
                .then((res) => {
                  setProp((props) => {
                    props.tweet = JSON.stringify(res.data.Output.message);
                  });
                })
                .catch((error) => {
                  // console.log(error);
                });
            }}
            className={`flex border bg-editor-bg-main items-center justify-center text-xs px-2 py-1 "
            `}
          >
            Embed
          </button>
          <br></br>
          <UnitInput
            isResponsive={true}
            valueTablet={widthTablet}
            valueMobile={widthMobile}
            resetValue={undefined}
            value={width}
            onChange={(val) => {
              setProp((props) => {
                props.width = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.widthTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.widthMobile = val;
              });
            }}
            label={"Width"}
          />
          <UnitInput
            isResponsive={true}
            valueTablet={heightTablet}
            valueMobile={heightMobile}
            resetValue={undefined}
            value={height}
            onChange={(val) => {
              setProp((props) => {
                props.height = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.heightTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.heightMobile = val;
              });
            }}
            label={"Height"}
          />
          <AlignInput
            value={align}
            isResponsive={true}
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            valueTablet={alignTablet}
            valueMobile={alignMobile}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.alignTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.alignMobile = val;
              });
            }}
            label={"Align"}
          />
        </Spacer>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </div>
    );
  }

  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: url },
        { key: widthTablet },
        { key: widthMobile },
        { key: width },
        { key: heightTablet },
        { key: heightMobile },
        { key: height },
        { key: align },
        { key: alignTablet },
        { key: alignMobile },
      ]),
    },
  ];

  return (
    <div>
      <Tabs items={tabs} id={`block-settings-tab-${id}`} />
    </div>
  );
};
